// extracted by mini-css-extract-plugin
export default {"bellIcon":"headerNotification_bellIcon__kJt4-","bellIndicator":"headerNotification_bellIndicator__sq8XZ","notificationItem":"headerNotification_notificationItem__l9mjp"};